import type { ReactNode } from "react";
import { Center, Stack, Text, Title } from "@mantine/core";
import { IonContent, IonPage } from "@ionic/react";
import { useSmdMigrationAccess } from "../hooks/useSmdMigrationAccess";
import type { MigrationEntryPoint } from "../utils/smdMigrationInterception";
import SmdMigrationContactPage from "../pages/SmdMigrationContactPage";
import { FHLoader } from "./FHLoader";
import FHButton from "./FHButton";

const SmdMigrationAccessUnavailable = () => (
  <IonPage>
    <IonContent>
      <Center h="100%" px="xl">
        <Stack align="center" maw={360} ta="center">
          <Title order={1} fz="xl">
            We couldn&apos;t verify your account
          </Title>
          <Text c="dimmed" fz="sm">
            Please check your connection and try again.
          </Text>
          <FHButton
            onClick={() => window.location.reload()}
            dataTestId="migration-access-retry"
          >
            Try again
          </FHButton>
        </Stack>
      </Center>
    </IonContent>
  </IonPage>
);

const SmdMigrationGate = ({
  children,
  entryPoint,
}: {
  children: ReactNode;
  entryPoint: MigrationEntryPoint;
}) => {
  const { status } = useSmdMigrationAccess();

  if (status === "loading") return <FHLoader />;
  if (status === "unavailable") return <SmdMigrationAccessUnavailable />;
  if (status === "contact_required") {
    return <SmdMigrationContactPage entryPoint={entryPoint} />;
  }

  return children;
};

export default SmdMigrationGate;
